import { render, staticRenderFns } from "./administrasi-kependudukan.vue?vue&type=template&id=07423b44"
import script from "./administrasi-kependudukan.vue?vue&type=script&lang=js"
export * from "./administrasi-kependudukan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports